module.exports = __webpack_public_path__ + "static/mao-97f4ce5ccb9ef89c537fc053a40df06c.jpg";